import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding-top: 65px;

  @media (max-width: 996px){
    padding-top: 56px;
  }
`;


// WEBPACK FOOTER //
// ./src/system/content/components.js